import { createNotifier } from "@/06-shared/lib/notifier";
import { ErrorPopup } from "@/06-shared/ui/errorPopup";
const extractErrorMessage = (error) => {
    var _a, _b;
    if (!error) {
        return null;
    }
    if (typeof error === "string") {
        return error.trim() || null;
    }
    if (error instanceof Error) {
        const message = (_a = error.message) === null || _a === void 0 ? void 0 : _a.trim();
        if (!message) {
            return null;
        }
        try {
            const parsed = JSON.parse(message);
            return (_b = parsed.message.trim()) !== null && _b !== void 0 ? _b : null;
        }
        catch (_c) {
            // fallback to the plain message below
        }
        return message;
    }
    return null;
};
export const { NotificationProvider: ErrorNotifier, useNotifier: useErrorNotification, } = createNotifier(ErrorPopup);
export const useErrorNotify = () => {
    const { showNotification } = useErrorNotification();
    return (error) => {
        const message = extractErrorMessage(error);
        if (message) {
            showNotification(message);
        }
    };
};
